import { fork, all } from 'redux-saga/effects';
// TODO: nadir login saga dışarı alınmalı
import loginSaga from '../components/Login/saga';

export default function * root() {
  yield all([
    fork(loginSaga)
  ]);
}
